import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  ICreateReviewPayload,
  ICreateReviewResponse,
  IGetReviewsPayload,
  IGetReviewsResponse,
  IUpdateReviewPayload,
  IUpdateReviewResponse
} from "../interfaces/IReviewV2";

const BASE_API = process.env.REACT_APP_BASE_API_V2;
const KRANKQUE_SECRET_KEY = process.env.REACT_APP_KRANKQUE_SECRET_KEY;
const KRANKQUE_APPLICATION_ID = process.env.REACT_APP_KRANKQUE_APPLICATION_ID;

export const reviewV2Slice = createApi({
  reducerPath: 'reviewV2',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState }) => {
      if (KRANKQUE_SECRET_KEY) {
        headers.set('krankque-secret-key', KRANKQUE_SECRET_KEY);
      }

      if (KRANKQUE_APPLICATION_ID) {
        headers.set('krankque-application-id', KRANKQUE_APPLICATION_ID);
      }

      return headers;
    }
  }),
  tagTypes: ['ReviewV2'],
  endpoints: (builder) => ({
    getReviewsV2: builder.mutation<IGetReviewsResponse, IGetReviewsPayload>({
      query: (req) => ({
        url: `/customer-reviews/${req.customerId}`,
        headers: {
          Authorization: `Bearer ${req.accessToken}`
        },
        method: 'POST',
        body: req.body
      })
    }),

    createReviewV2: builder.mutation<ICreateReviewResponse, ICreateReviewPayload>({
      query: (req) => ({
        url: `/review`,
        headers: {
          Authorization: `Bearer ${req.accessToken}`
        },
        method: 'POST',
        body: req.body
      })
    }),

    updateReviewV2: builder.mutation<IUpdateReviewResponse, IUpdateReviewPayload>({
      query: (req) => ({
        url: `/review/${req.reviewId}`,
        headers: {
          Authorization: `Bearer ${req.accessToken}`
        },
        method: 'PUT',
        body: req.body
      })
    }),
  }),
});

export const { useGetReviewsV2Mutation, useCreateReviewV2Mutation, useUpdateReviewV2Mutation } = reviewV2Slice;

